import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './app.css';
import mdFile from '../../README.md';
import rehypeRaw from 'rehype-raw';

function App() {
  return <div className="app">
    <ReactMarkdown rehypePlugins={[rehypeRaw]}>{mdFile}</ReactMarkdown>
  </div>;
}

export default App;
